import { Schema } from "effect";
import type { BaselineQuery } from "./query-owner.ts";
import { WorkspaceBaseline } from "../../api/workspace-changes/model.ts";
export const BaselineSelection = Schema.Struct({ workspaceId: Schema.NullOr(Schema.String), refreshToken: Schema.Number });
export type BaselineSelection = typeof BaselineSelection.Type;
export const BaselineSnapshot = Schema.Struct({
  selectionKey: Schema.String, workspaceId: Schema.NullOr(Schema.String),
  baseline: Schema.NullOr(WorkspaceBaseline), retainedBaseline: Schema.NullOr(WorkspaceBaseline),
  error: Schema.NullOr(Schema.String), loading: Schema.Boolean, closed: Schema.Boolean
});
export type BaselineSnapshot = typeof BaselineSnapshot.Type;
export interface BaselineRequest extends BaselineQuery { readonly selectionKey: string }
export interface BaselineState {
  readonly selection: BaselineSelection | null;
  readonly data: WorkspaceBaseline | null;
  readonly error: { readonly workspaceId: string; readonly message: string } | null;
  readonly request: BaselineRequest | null;
  readonly closed: boolean;
}
export const baselineSelectionKey = (selection: BaselineSelection): string => JSON.stringify([selection.workspaceId, selection.refreshToken]);
export const emptyBaselineState = (): BaselineState => ({ selection: null, data: null, error: null, request: null, closed: false });
export const baselineSnapshot = (state: BaselineState): BaselineSnapshot => {
  const workspaceId = state.selection?.workspaceId ?? null;
  return { selectionKey: state.selection ? baselineSelectionKey(state.selection) : "", workspaceId,
    baseline: state.data?.workspaceId === workspaceId ? state.data : null, retainedBaseline: state.data,
    error: state.error?.workspaceId === workspaceId ? state.error.message : null,
    loading: state.request !== null, closed: state.closed };
};
